module.exports = __webpack_public_path__ + "img/nose_female_wide.fbcc9474.png";